<template>
  <div class="system-slow-modal">
    <form @submit.prevent="submit">
      <p class="intro">
        המערכת איטית? כתבו מה בדיוק איטי — איזה מסך או פעולה, ממתי זה קורה, וכמה זמן זה לוקח.
        המערכת תתחקר את הסיבה ותנסה לתקן. המערכת גם תופעל מחדש כעת לזירוז מיידי.
      </p>

      <div class="field">
        <label class="label">פירוט התקלה *</label>
        <div class="control">
          <textarea
            v-model="details"
            class="textarea"
            :class="{ 'is-danger': showError }"
            rows="5"
            placeholder="לדוגמה: מסך המשרות נטען 20 שניות מאז הבוקר; חיפוש מועמדים נתקע בטעינה..."
            @input="showError = false"
          ></textarea>
        </div>
        <p class="help" :class="charsLeft > 0 ? 'is-danger' : 'has-text-grey'">
          <template v-if="charsLeft > 0">חסרים עוד {{ charsLeft }} תווים (מינימום 10)</template>
          <template v-else>{{ details.trim().length }} תווים</template>
        </p>
      </div>

      <div class="field is-grouped is-grouped-right mt-4">
        <div class="control">
          <button
            type="submit"
            class="button is-info"
            :class="{ 'is-loading': loading }"
            :disabled="loading || charsLeft > 0"
          >
            שלח דיווח והפעל מחדש
          </button>
        </div>
        <div class="control">
          <button type="button" class="button" :disabled="loading" @click="closeModal">
            ביטול
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SystemSlowModal',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      showError: false,
      details: ''
    }
  },
  computed: {
    charsLeft () {
      return Math.max(0, 10 - this.details.trim().length)
    }
  },
  methods: {
    closeModal () {
      if (this.payload && this.payload.onClose) {
        this.payload.onClose()
      }
    },
    reporterName () {
      const owner = this.$utils.getOwner ? this.$utils.getOwner() : null
      return (owner && (owner.full_name || owner.name)) || 'אדמין'
    },
    shortId (id) {
      return (id || '').toString().slice(0, 8)
    },
    async submit () {
      if (this.charsLeft > 0) {
        this.showError = true
        this.$utils.emit('show_toast', { text: 'נא לכתוב פירוט של 10 תווים לפחות', type: 'error' })
        return
      }
      this.loading = true
      try {
        const res = await this.$network_utils.reportSystemSlow({
          details: this.details.trim(),
          reportedBy: this.reporterName(),
          pageUrl: window.location.href
        })
        const id = this.shortId(res && res.task && res.task.id)
        this.$utils.emit('show_toast', {
          text: id
            ? `נפתחה משימת בדיקה (#${id}) — המערכת תתחיל לתחקר. המערכת הופעלה מחדש לזירוז.`
            : 'הדיווח נשלח והמערכת הופעלה מחדש לזירוז.',
          type: 'success'
        })
        this.closeModal()
      } catch (error) {
        const resp = error && error.response
        if (resp && resp.status === 409) {
          // A prior "system slow" report is still being handled — anti-spam.
          const open = (resp.data && resp.data.already_open) || {}
          const id = this.shortId(open.id)
          this.$utils.emit('show_toast', {
            text: id
              ? `כבר קיימת משימת בדיקה פתוחה (#${id})${open.status ? ' בסטטוס "' + open.status + '"' : ''} שעדיין בטיפול. המערכת הופעלה מחדש לזירוז.`
              : 'כבר קיים דיווח פתוח שעדיין בטיפול. המערכת הופעלה מחדש לזירוז.',
            type: 'warning'
          })
          this.closeModal()
        } else {
          this.$utils.emit('show_toast', {
            text: 'שגיאה בשליחת הדיווח: ' + ((resp && resp.data && resp.data.message) || (error && error.message) || 'שגיאה לא ידועה'),
            type: 'error'
          })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.system-slow-modal {
  padding: 20px;
  direction: rtl;
}
.intro {
  margin-bottom: 16px;
  line-height: 1.5;
  color: #444;
}
.textarea, .label, .help, .intro {
  text-align: right;
}
</style>
